import axios from "axios";
import { track } from "@/utils/analytics";
import { isInternalUrl, isSafeUrl } from "@/utils/richText";

// One emoji per kind instead of a colored dot.
const ICONS = {
  booking_new: "📅", booking_canceled: "🚫", booking_rescheduled: "🔁", booking_blocked: "⛔",
  payment_confirmed: "✅", payment_overdue: "💳", plan_ended: "💳", over_limit: "⚠️", ai_quota: "✨",
  trial_ending: "⏳", welcome_offer: "🎁", referral_reward: "🎁", referral_signup: "🤝",
  terms_update: "📄", intake_filled: "📝", video_waiting: "🎥", import_done: "📥", import_failed: "⚠️",
  tomorrow_summary: "🗓️", scale_completed: "📊", document_signed: "✍️", homework_done: "📌",
  birthday: "🎂", notes_reminder: "🖊️", first_note: "🖊️",
  suggestion_done: "💙", team_message: "💙", product_news: "🆕",
};

export function kindIcon(kind) {
  return ICONS[kind] || "🔔";
}

// Kinds that come from the team (shown with a soft highlight).
export const TEAM_LIKE = ["suggestion_done", "team_message", "product_news"];

export function markReadRemote(id) {
  return axios.patch(`/api/v1/notifications/${id}`, { meta: { contentType: "application/json" } }).catch(() => {});
}

// Internal paths go through the router, external links open in a new tab (noopener).
export function openUrl(router, url) {
  if (!isSafeUrl(url)) return;
  if (isInternalUrl(url)) router.push(url).catch(() => {});
  else window.open(url, "_blank", "noopener");
}

// where: bell | modal | page. which: item | link | primary | secondary.
export function trackClick(n, which, where) {
  track("notification_click", { kind: n.kind, action: which, where });
}

export function ago(v) {
  const diff = (Date.now() - new Date(v).getTime()) / 60000;
  if (diff < 1) return "agora";
  if (diff < 60) return `há ${Math.round(diff)} min`;
  if (diff < 1440) return `há ${Math.round(diff / 60)} h`;
  return new Date(v).toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" });
}
